module.exports = __webpack_public_path__ + "img/access-denied.e59642a8.png";